export function getParagraph(element) {
  return element && element.closest ? element.closest("p[data-para]") : null;
}

export function getPage(element) {
  return element && element.closest ? element.closest(".book-page[id]") : null;
}

export function textOffsetWithin(container, targetNode, targetOffset) {
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
  let offset = 0;
  let current;

  while ((current = walker.nextNode())) {
    if (current === targetNode) {
      return offset + targetOffset;
    }
    offset += current.nodeValue.length;
  }

  return null;
}

export function resolveTextPosition(container, charOffset) {
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
  let remaining = charOffset;
  let current;

  while ((current = walker.nextNode())) {
    const length = current.nodeValue.length;
    if (remaining <= length) {
      return { node: current, offset: remaining };
    }
    remaining -= length;
  }

  if (container.lastChild && container.lastChild.nodeType === Node.TEXT_NODE) {
    return { node: container.lastChild, offset: container.lastChild.nodeValue.length };
  }

  return null;
}
